import $ from "jquery";

const CAPACITOR_SERVER_ORIGIN = 'https://safety.inspectpro.seasonai.net';
const DEFAULT_REQUEST_TIMEOUT_MS = 10000;

function isNativePlatform(): boolean {
    const capacitor = (window as any).Capacitor;
    return !!capacitor && !!capacitor.isNativePlatform && capacitor.isNativePlatform();
}

function resolveUrl(url: string): string {
    const normalized = String(url || '').trim();
    if (!normalized) return normalized;
    if (/^https?:\/\//.test(normalized)) return normalized;
    if (!isNativePlatform()) return normalized;

    if (normalized.startsWith('/')) {
        return `${CAPACITOR_SERVER_ORIGIN}${normalized}`;
    }

    return `${CAPACITOR_SERVER_ORIGIN}/${normalized}`;
}

export default class Request {
    constructor() { }

    public async post(url: string, data: any = {}) {
        const resolvedUrl = resolveUrl(url);

        let request = () => {
            return new Promise((resolve) => {
                $.ajax({
                    url: resolvedUrl,
                    type: "POST",
                    data: data,
                    crossDomain: /^https?:\/\//.test(resolvedUrl),
                    xhrFields: {
                        withCredentials: true
                    },
                    timeout: DEFAULT_REQUEST_TIMEOUT_MS
                }).always(function (res) {
                    resolve(res);
                });
            });
        }

        return await request();
    }

}
